  <bzg-welcome-landing topTitle="{{ 'AUTOADMIN.TOP_TITLE' | translate }}" middleTitle="{{ 'AUTOADMIN.MIDDLE_TITLE' | translate }}" bottomTitle="{{ 'AUTOADMIN.BOTTOM_TITLE' | translate }}">
    <h4 class="bmc-email-sent__title">{{ 'AUTOADMIN.EMAIL_SENT' | translate }}</h4>
    <p class="bmc-email-sent__paragraph">{{ 'AUTOADMIN.EMAIL_SENT_DESCRIPTION' | translate }}</p>
    <a class="bmc-email-sent__link" href="javascript:;" (click)="back()">
        <svg class="bz-icon-svg bz-icon-svg--16 bmc-email-sent__link__icon" >
            <use href="#chevron-left"></use>
        </svg>
        {{ 'AUTOADMIN.BACK' | translate }}
    </a>
  </bzg-welcome-landing>
